// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"4ad94640","583":"3831b724","983":"16bb3355"}[chunkId] + ".chunk.js";
};